import { render, staticRenderFns } from "./AddAlbumModal.vue?vue&type=template&id=757cf8e0&lang=pug&"
import script from "./AddAlbumModal.vue?vue&type=script&lang=js&"
export * from "./AddAlbumModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports